module.exports = __webpack_public_path__ + "static/media/cigar3.506b42ac.jpg";